import { render, staticRenderFns } from "./QuestionsResult.vue?vue&type=template&id=7a12317c&"
import script from "./QuestionsResult.vue?vue&type=script&lang=js&"
export * from "./QuestionsResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports